/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Withdrawal_Status_OpenInputs */

const vi_scl_withdrawal_status_open = /** @type {(inputs: Scl_Withdrawal_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang mở`)
};

/**

* @param {Scl_Withdrawal_Status_OpenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_withdrawal_status_open = /** @type {((inputs?: Scl_Withdrawal_Status_OpenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Withdrawal_Status_OpenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_withdrawal_status_open(inputs)
});